import CustomPageTiles from '../components/CustomPageTiles';
import Header from '../components/Header';

function Misc() {
  return <>
    <Header />

    <div id="tiles">
        <CustomPageTiles path="/misc" />
    </div>
  </>
}

export default Misc;
